export function isEmail(value: string): boolean {
	// tslint:disable-next-line:max-line-length
	const pattern =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return pattern.test(value.toLowerCase());
}

export function isPhoneNumber(value: string): boolean {
	// tslint:disable-next-line:max-line-length
	const pattern = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/;
	return pattern.test(value.toLowerCase());
}

export function isNumber(value: string): boolean {
	const pattern = /[0-9]/;
	return pattern.test(value);
}
